/**
 * Import blocks as components.
 */
import "./gutenberg/gallery-folder-block";
